import { render, staticRenderFns } from "./DialogBaseBlue.vue?vue&type=template&id=0126fd1d&scoped=true"
import script from "./DialogBaseBlue.vue?vue&type=script&lang=js"
export * from "./DialogBaseBlue.vue?vue&type=script&lang=js"
import style0 from "./DialogBaseBlue.vue?vue&type=style&index=0&id=0126fd1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126fd1d",
  null
  
)

export default component.exports